import { IUntypedCommand, Topics } from '@zaplify/common';

export class RemoveProspectsFromSourceCommand extends IUntypedCommand {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly sourceId: string, readonly prospectIds: string[]) {
        super();
    }
}
